import { atom } from 'jotai';

//Filtry na głównej stronie:
export const useMainFilter = atom('');//
export const useSecondFilter = atom('');//
export const usePriceFilter = atom(false);//
export const useFilteredMinPrice = atom('');//
export const useFilteredMaxPrice = atom('');//
export const useFilteredMinSquare = atom('');//
export const useFilteredMaxSquare = atom('');//
export const useFilteredMarket = atom('');//
export const useFilteredCity = atom('');
export const useFilteredDistrict = atom('');
export const useFilteredStreet = atom('');
export const useCurrencyFilter = atom('');
export const useExperienceFilter = atom('');
export const useSearchInputValue = atom('');
export const useCountryFilter = atom('');
export const useCityFilter = atom('');


//Ogólne:
export const useLoggedUser = atom(false);
export const useDownloadedOffers = atom('');
export const useStepper = atom(1);
export const useOffersToDisplay = atom('');
export const useRefreshUserInfo = atom(0);
export const useSearchedCompany = atom('');
export const useDetailedOffer = atom('');
export const useStatuteAcceptation = atom(false);
export const useOpenedOfferIndex = atom(0);
export const useChoosedOption = atom('');
export const useShowPopUpModal = atom(false);
export const useModalVersion = atom(false);
export const useModalInfo = atom(false);
export const useShowDetailedCard = atom(0);
export const useMobileMapView = atom(false);
export const useAllCompanies = atom('');
export const useExpiredOffers = atom('');
export const useOfferApplications = atom('');
export const useCompaniesLogosUrls = atom('');
export const useApplyWithSJProfile = atom('');
export const useExternalApplyUrl = atom('');
export const useDetailed = atom('');
export const useCompanyUrlConstructor = atom('');
export const useUploadProgress = atom('');
export const useDisplayCookiesInfo = atom(true);
export const useShowLoadingAnim = atom(false);
export const useYTUrl = atom('');


// Dotyczące dodawania oraz edycji ogłoszeń:

export const useSelectedMainCategory = atom('Wybierz');
export const useSelectedSpeciality = atom('Wybierz');
export const useSelectedMarket = atom('Wybierz');
export const useSelectedPrice = atom('');
export const useSelectedCity = atom('');
export const useSelectedTitle = atom('');
export const useSelectedDescription = atom('');
export const useSelectedStreet = atom('');
export const useSelectedDistrict = atom('');
export const useSelectedBuilding = atom('');
export const useSelectedLocal = atom('');
export const useSelectedAdressLat = atom('');
export const useSelectedAdressLng = atom('');
export const useSelectedSquareFootage = atom('');
export const useSelectedBuildYear = atom('');
export const useSelectedBuildStatus = atom('');
export const useSelectedElevatorStatus = atom('');
export const useSelectedRoomsNumber = atom('');
export const useSelectedFloorNumber = atom('');
export const useSelectedFloorsNumberInBuilding = atom('');
export const useSelectedHeatingType = atom('');
export const useSelectedParkingSpot = atom('');
export const useSelectedBalconyNumber = atom('');
export const useSelectedBasementInfo = atom('');
export const useSelectedMeasuresHeight = atom('');
export const useSelectedMeasuresWidth = atom('');
export const useSelectedRoadType = atom('');
export const useSelectedImages = atom([]); // { file, url }
export const useSelectedLandMedia = atom([]); // { file, url }
export const useSelectedBussinesAdditions = atom([]); // { file, url }
export const useSelectedBussinesMedia = atom([]); // { file, url }
export const useImagesLoading = atom('');
export const useAwaitOffer = atom('');